import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'
// eslint-disable-next-line
import i18n from './i18n.js'
import './bootstrap'
import './theme.scss'
import {Router} from 'react-router-dom'
import {createBrowserHistory} from 'history'

const history = createBrowserHistory()
const rootElement = document.getElementById('root')

ReactDOM.render(
  <Router history={history}>
    <App />
  </Router>,
  rootElement
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
